var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import ScrollTopCss from "./ScrollTopCss.js";
import './../../external/@lit/reactive-element/reactive-element.js';
import { html as y } from './../../external/lit-html/lit-html.js';
import { LitElement as s } from './../../external/lit-element/lit-element.js';
class ScrollTop extends s {
  constructor() {
    super(...arguments);
    __publicField(this, "showScrollTop", () => {
      const button = this.shadowRoot.querySelector("#scrolltop");
      if (window.scrollY > 20) {
        button.classList.remove(this.hideClass);
      } else {
        button.classList.add(this.hideClass);
      }
    });
  }
  static get styles() {
    return [ScrollTopCss];
  }
  static get properties() {
    return {};
  }
  connectedCallback() {
    super.connectedCallback();
    this.hideClass = "hidden";
    window.addEventListener("scroll", this.showScrollTop);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("scroll", this.showScrollTop);
  }
  render() {
    return y`
      <style>
        @import '${iscecoWidgetLibrary.iconCss}'
      </style>
      <button id="scrolltop"
              class="${this.hideClass}"
              title=" "
              @click="${(_) => scrollToTop()}">
        <i class="chevron up icon"></i>
      </button>
    `;
  }
}
customElements.define("isceco-scroll-top", ScrollTop);
export { ScrollTop as default };
